// extracted by mini-css-extract-plugin
export default {"modalOuter":"style_modalOuter__g66K1","modal":"style_modal__XfmyB"};